namespace('compass.arctic');

compass.arctic.HeaderWidget = compass.defineWidget(function HeaderWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _headerDescription;
	var _showInfoWidget;

	this.setupControls = function() {

	};

	this.setMeetingData = function(data) {

	};

	this.render = function(widgetElem) {
		var d = _d;
		_headerDescription = d.h2({ tabindex : -1 });
		
		// Create container for event details
		var eventDetailsContainer = d.h1({ className: 'eventHeader' });

		var widgetContents = [
			me.drawEventLogo(),
			eventDetailsContainer,
			d.reader(_headerDescription),
			d.separator()
		];

		widgetElem.append(
			widgetContents
		).attr({'aria-role':'banner', 'role': 'banner'});
		
		// Create ShowInfoWidget instance - it will auto-render into the container
		_showInfoWidget = new compass.arctic.ShowInfoWidget(eventDetailsContainer, {
			meetingInfo: _settings.meetingInfo
		});

		me.setupControls();
	};

	function goHome() {
		return;
		//window.location =  compass.rootPrefix + '/' + compass.matchDict.meetingCode;
	}

	this.setHeaderDescription = function(headerDescription){
		// prepend a string that a screen reader can read to the header (for better readibility of each page)
		_headerDescription.text(headerDescription).focus();
	};

	// Deprecated - now handled by ShowInfoWidget
	// Kept for reference in case we need to revert
	/*
	this.drawEventDetails = function() {
		var d = _d;
		var mi = _settings.meetingInfo;
		var addr = d.div({ className : 'eventAddr' },
			d.span({ className : 'eventCity' }, mi.site.city)
		);

		if(mi.site.state) {
			addr.append(d.span({ className : 'eventState' }, ',&nbsp;', mi.site.state));
		}
		if(mi.site.country.toLowerCase() != 'united states') {
			addr.append(
				d.span({ className : 'eventCountry' }, 
					',&nbsp;', mi.site.country.toLowerCase()
				)
			);
		}

		var eventDetails = d.div({ className : 'eventDetails' },
			d.div({ className : 'eventDates' }, mi.datesDisplay),
			d.div({ className : 'eventLocation notranslate' }, mi.site.name),
			addr
		);

		if(mi.hideMeetingSubheader) {
			eventDetails.empty();
		}

		var eventHeader = d.div({ className : 'eventHeader'},
			d.div({ className : 'eventName notranslate' }, mi.name),
			eventDetails
		).activate(goHome);
		
		// Add redesign toggle for development
		if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev') || window.location.hostname.includes('.local') || window.location.search.includes('showRedesignToggle=true')) {
			var currentState = compass.isRedesignEnabled();
			var toggleButton = d.button({
				className: 'redesign-toggle-btn',
				title: 'Toggle between legacy and redesign mode'
			}, currentState ? 'Legacy Mode' : 'Redesign Mode');
			
			toggleButton.activate(function() {
				// Set cookie to opposite of current state
				var newState = !currentState;
				compass.setCookieValue('arctic_redesign_override', newState ? 'true' : 'false', false);
				
				// Reload page to apply new mode
				window.location.reload();
			});
			
			eventHeader.append(toggleButton);
		}
		
		return eventHeader;
	};
	*/

	this.drawEventLogo = function() {
		var d = _d;
		var logo = d.div({ className : 'eventLogo'});
		logo.html(_settings.meetingInfo.headerContent);
		return logo;
	};

	var _d = jQuery.dom.getContext(this);
},
{ WUID : 'defaultHeaderWidgetWUID',
	widgetName : 'HeaderWidget',
	meetingInfo : {headerContent : "", "starts": "04/29/2012", "ends": "05/01/2012", "datesDisplay" : "Oct 12-15, 1337", "name": "Generic Test 111029125332", "site": {"latitude": 41.8554, "name": "McCormick Place Convention Center", "longitude": -87.6152, city : "Orlando", state : "FL"}
	}
}
);

